module.exports = __webpack_public_path__ + "static/media/star-empty-grey.0e1751a4.svg";